const SIGN_OUT_SUCCESS = "authentication/SIGN_OUT_SUCCESS";
const SIGN_IN_SUCCESS = "authentication/SIGN_IN_SUCCESS";

export default {
  SIGN_OUT_SUCCESS,
  SIGN_IN_SUCCESS
};
